import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => {
	return {
		header: {
			display: 'flex',
			justifyContent: 'space-between',
			width: '100%',
			alignItems: 'center',
			[theme.breakpoints.up("md")]: {
				paddingBottom: theme.spacing(2),
			}
		},
		menuButton: {
			display: "block",
			[theme.breakpoints.down("sm")]: {
				color: theme.palette.common.white,
				marginRight: theme.spacing(5)
			},
			[theme.breakpoints.up("sm")]: {
				color: theme.palette.common.black,
				margin: 'inherit',
				'&:hover': {
					backgroundColor: theme.palette.primary.main,
				}
			},
		},
		inferiorArea: {
			alignItems: 'flex-end',
			justifyContent: 'center',
			marginRight: 5,
			display: "flex",
			[theme.breakpoints.up("sm")]: {
				marginRight: 20
			},
		},
		userButton: {
			width: 120,
			height: 54,
			borderRadius: 0,
			marginBottom: 15,
			marginTop: 15,
			[theme.breakpoints.up("sm")]: {
				width: 170,
				height: 54,
				borderRadius: 0,
				marginBottom: 20
			},
		},
		notHamburguer: {
			display: "none",
		},
		menuToggleDrawer: {
			display: 'flex',
			width: '40%',
			alignItems: 'center',
			justifyContent: 'flex-start',
			paddingLeft: 60,
			[theme.breakpoints.down("md")]: {
				width: '22%',
				paddingLeft: 0,
			}
		},
		menuDrawerOpened: {
			display: 'flex',
			width: '40%',
			alignItems: 'center',
			justifyContent: 'flex-start',
			[theme.breakpoints.down("md")]: {
				width: '22%',
			}
		},
		toolbar: {
			height: 'auto',
			alignItems: 'flex-start',
			paddingTop: theme.spacing(1),
			flexDirection: 'column',
			[theme.breakpoints.up("md")]: {
				paddingLeft: theme.spacing(0),
				backgroundColor: theme.palette.common.white,
				minHeight: 5,
			}
		},
		title: {
			flexGrow: 1,
			alignSelf: 'flex-start',
			paddingLeft: theme.spacing(3),
			paddingBottom: theme.spacing(2),
			[theme.breakpoints.down("md")]: {
				alignSelf: 'center',
				paddingLeft: theme.spacing(3),
			}
		},
		content: {
			backgroundColor: 'white'
		},
		notificationsPanel: {
			color: '#7f7f7f',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-around',
			[theme.breakpoints.up("sm")]: {
				width: '8rem',
			},
		},
		notificationsPanelTitle: {
			fontWeight: 'bold',
			cursor: 'pointer'


		},

		notificationButton: {
			color: theme.palette.common.white,
			[theme.breakpoints.up("md")]: {
				color: '#7F7F7F'
			}
		},
		badge: {
			color: theme.palette.common.white,
			backgroundColor: theme.palette.red.main
		},
		link: {
			textDecoration: "none"
		}
	}
});

export default useStyles;